export const API_URL = 'https://ek-tester.ru/api';
